/**
 * This is table-cell script.js file
 */
import DispatchersMixin from '@/mixins/dispatchers';
import { generateTabPayload } from '@/use/menu.space';

export default {
    /**
     * @override
     * returns the list of date fields, if any date field on tables needs to be formatted
     * to format dd-mm-yyyy, include its name on the array date_fields
     */
    data() {
        return {
            datetime_fields: [
                'created_on',
                'expires_on',
                'updated_on',
                'registration_date',
                'opening_date',
                'closing_date',
                'blocking_date',
                'resolved_on',
                'first_subscription_date',
                'last_subscription_date',
                'request_date',
                'deleted_on',
                'aml_checked_on'
            ],
            date_fields: [
                'decease_date',
                'deathdate',
                'birthdate',
                'birth_date',
                'lei_expiration_date',
                'first_payment_date',
                'date_of_asset_value',
                'document_expiration_date',
                'operation_date',
                'nav_date',
                'pp_redemption_entitlement_date',
                'per_start_date'
            ],
            country_fields: [
                'key_country_of_birth',
                'key_country_nationality1',
                'key_country_nationality2',
                'key_nationality_1',
                'key_nationality_2',
                'f_address_key_country'
            ],
            currency_fields: ['gross_amount', 'net_amount'],
            number_fields: ['intervener_issues_count', 'operation_issues_count'],
            titularIdx: 0
        };
    },
    name: 'VTableCell',
    mixins: [DispatchersMixin],
    props: {
        self: {
            type: Array,
            required: true
        },
        row: {
            type: Object,
            required: true
        },
        field: {
            type: String,
            required: true
        },
        section: {
            type: String,
            required: true
        },
        widths: {
            type: Object,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos el valor de una celda
         * @param {Object} item Objeto del array de datos
         * @param {String} field Campo que queremos obtener el item
         * @return {Array} Devuelve el valor de la celda
         */
        value(item, field) {
            return item[field];
        },
        /**
         * @override
         */
        isLinkable(column) {
            return this.self.findIndex(x => x === column) >= 0;
        },
        /**
         * @override
         */
        constructFullName(intervener) {
            let name = intervener.name ? `${intervener.name}` : '';
            name += intervener.lastname_1 ? ` ${intervener.lastname_1}` : '';
            name += intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
            name = name.trim();
            return name;
        },
        /**
         * @override
         */
        addItemMenu(row) {
            const selfname = row.intervener_type ? this.constructFullName(row) : row._self_name;
            const item = generateTabPayload(selfname, `${this.section}_uuid`, { name: selfname, uuid: row.uuid });
            this.setMenuTab(item);
        },
        /**
         * Show account interveners
         * @param {Number} index of account to show
         */
        showAccountInterveners(index) {
            this.$bvModal.show(`modalShowAccountInterveners-${index}`);
        },
        /**
         * Show account interveners
         * @param {Number} index of account to show
         */
        hideAccountInterveners(index) {
            this.$bvModal.hide(`modalShowAccountInterveners-${index}`);
        },
        
        getStatusColorClass(status) {
            if (!status) return '';
            const registeredStates = ['REGISTERED', 'REGISTERED_POSTAL', 'REGISTERED_ONLINE', 'REGISTERED_EMAIL'];
            const blockedStates = ['BLOQUEADO', 'BLOQUEADO_AML', 'CANCELLED'];
            const validatedStates = ['VALIDADO', 'VALIDATED', 'RESOLVED'];
            const awaitingStates = [
                'SIGNED', 
                'SOLICITUD_PENDIENTE_ENVÍO_INTERCAMBIO', 
                'TRASPASO_RECIBIDO_PENDIENTE_VALORAR', 
                'SOLICITUD_TRASPASO_SALIDA_PENDIENTE', 
                'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALOR'
            ];
            const finalizedStates = ['FINALIZADO', 'PERIODIC_ACTIVE', 'FINALIZED'];
            const rejectedStates = ['PERIODIC_SUSPENDED', 'ENVIADO_RECHAZO', 'RECIBIDO_RECHAZADO'];
            const sentStates = ['ENVIADO', 'IN-PROGRESS', 'RD_SENT', 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN', 'TRANSFERNCIA_ENVIADA'];

            if (registeredStates.includes(status)) return 'color-registered';
            if (blockedStates.includes(status)) return 'color-blocked';
            if (validatedStates.includes(status)) return 'color-validated'
            if (awaitingStates.includes(status)) return 'color-awaiting';
            if (finalizedStates.includes(status)) return 'color-finalized';
            if (rejectedStates.includes(status)) return 'color-rejected';
            if (sentStates.includes(status)) return 'color-sent';
            return '';
        },

        formatExternalCodes(row) {
            const codes = row?.external_code;
            if (typeof codes === 'string' && codes.trim() !== '') {
                // separar por uno o más espacios
                const list = codes.trim().split(/\s+/).filter(Boolean);

                if (list.length > 1) {
                    // eliminar duplicados y unir con coma
                    const unique = Array.from(new Set(list));
                    return unique.join(', ');
                }

                // solo un código
                return list[0];
            }

            // sin códigos
            return '-';
        }

    },
    mounted() {
        if (this.field === 'interveners' && this.$route.name !== 'issues' && this.value(this.row, this.field)) {
            this.value(this.row, this.field).forEach((element, idx) => {
                if ( element.account_roles && element.account_roles.includes('TITULAR')) {
                    this.titularIdx = idx;
                }
            });
        }
    }
};
